/**
 * Serializa um valor de resposta SurveyJS para uma célula de texto. Escalares
 * viram string direta; arrays (checkbox múltiplo, ranking) viram lista separada
 * por vírgula; objetos (matriz) viram JSON compacto; null/undefined → vazio.
 */
export function formatAnswerCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (Array.isArray(value)) return value.map((v) => formatAnswerCell(v)).join(', ');
  try {
    return JSON.stringify(value);
  } catch {
    return '';
  }
}

/**
 * Formata o instante de conclusão para o fuso do VIEWER (data-timezone-standard:
 * `completedAt` é um INSTANTE). `Intl` com `timeZone` explícito — nunca o fuso
 * implícito da máquina.
 *
 * EU-739: com a geração da planilha movida para o backend, o fuso do viewer
 * deixou de ser descobrível pelo ambiente — o pod roda em UTC. Por isso o
 * `timeZone` virou parâmetro: o SPA informa o seu (via BFF → Core) e o
 * comportamento de sempre é preservado. Sem parâmetro (chamadas do browser,
 * export por etapa), o default continua sendo o fuso da máquina do viewer.
 * Um IANA inválido cai para `America/Sao_Paulo` em vez de derrubar o export.
 */
export function formatCompletedAt(iso: string | null, timeZone?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const tz = timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone ?? 'America/Sao_Paulo';
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short',
      timeZone: tz,
    }).format(d);
  } catch {
    return new Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short',
      timeZone: 'America/Sao_Paulo',
    }).format(d);
  }
}
